import { getVideoLibrary } from "../community/videoLibrary";
import { VideoLibraryItem } from "../../types/Community";

// The pipeline views read every media ops collection through the mediaOps
// callable (list_media_projects, list_social_campaigns, get_media_review and
// the rest). The only direct read left is the community video library, which
// is not a media ops collection: the Assets view uses it to pick a library
// item to register as owned media.

export const loadLibraryItems = (communityId: string): Promise<VideoLibraryItem[]> => getVideoLibrary(communityId);
